import '../../index.css';
var styles = {
  "legendText": "bp_legend_module_legendText--b241b",
  "fieldset": "bp_legend_module_fieldset--b241b",
  "legend": "bp_legend_module_legend--b241b",
  "wide": "bp_legend_module_wide--b241b"
};
export { styles as default };